import { Suspense, useCallback, useState, lazy } from "react";
import { AuthViews } from "./types";
import { Box } from "@mui/material";

const SignUp = lazy(() => import("./sign-up"));
const SignIn = lazy(() => import("./sign-in"));
const ForgotPassword = lazy(() => import("./forgot-password"));

function AuthViews() {
  const [currentView, setCurrentView] = useState<AuthViews>("SIGN_IN");

  const handleChangeView = useCallback((view: AuthViews) => {
    setCurrentView(view);
  }, []);

  const renderView = (view: AuthViews) => {
    switch (view) {
      case "SIGN_IN":
        return (
          <Suspense fallback={"loading..."}>
            <SignIn onChangeView={handleChangeView} />
          </Suspense>
        );
      case "SIGN_UP":
        return (
          <Suspense fallback={"loading..."}>
            <SignUp onChangeView={handleChangeView} />
          </Suspense>
        );
      case "FORGOT_PASSWORD":
        return (
          <Suspense fallback={"loading..."}>
            <ForgotPassword onChangeView={handleChangeView} />
          </Suspense>
        );
      default:
        return (
          <Suspense fallback={"loading..."}>
            <SignIn onChangeView={handleChangeView} />
          </Suspense>
        );
    }
  };

  return <Box>{renderView(currentView)}</Box>;
}

export default AuthViews;
